import React from 'react';
import PropTypes from 'prop-types';

const Pill = props => (
  <div className={`ds-pill ds-pill-${props.type} ${props.className}`}>
    {props.children}
  </div>
);

Pill.defaultProps = {
  children: null,
  className: '',
  type: 'default',
};

Pill.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.oneOf(
    [
      'alt',
      'danger',
      'default',
    ],
  ),
};

export default Pill;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Pill/index.jsx